<!--Banner part code-->
<div class="uk-child-width-1-1@s" uk-grid>
    <div>
        <div class="uk-background-cover uk-height-large uk-panel uk-flex-center uk-flex-middle"
               style="background-image: url(../../assets/laravelbanner.png);">
            <div class="uk-section uk-light">
                <div class="uk-container-small uk-width-2xlarge" >
                    <div><h1 class="uk-text-bold uk-padding-large uk-padding-remove-vertical"  style="margin-bottom: 10px;">Laravel Application Development Services</h1></div>
                    <div>

                       

                        <p class="uk-padding-large uk-text-left  uk-padding-remove-vertical" style= "font-size: 20px;">
                            We always combines the very best of what we have seen in all other web frameworks. Laravel is  providing powerful tools needed for large, robust applications. 

                            
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> 
<!--Banner part code ends-->
    <div class="uk-section uk-padding" style=" padding-bottom: 0px;">
        <div class="uk-container">
          
              <h2 class="uk-text-center" style="font-weight: 600;">Developing the Right Application in Laravel for your Business</h2>
              <br>
              <div class="uk-column-1-2@s">
                    <p class="uk-text-medium uk-text-justify" style="font-size: 18px;">Laravel is an open-source PHP framework, which is robust, efficient and easy to understand. It follows a model-view-controller design pattern in processing. Laravel reuses the existing components of different frameworks which helps in creating a web app. The web application thus designed is more structured and realistic. A superb combination of simplicity, elegance, and innovation gives you a complete toolset required to build any application with which you want to reach your business goals</p>
                    <p class="uk-text-medium uk-text-justify" style="font-size: 18px;">Laravel is a web application framework with expressive, refined syntax. We believe development must be an enjoyable, creative and effective experience to be truly fulfilling.  Laravel aims to make the development process a pleasing one for the developer.
                        </p>
                     <img data-src="assets/laravel-6.png" width="700" height="700" alt="" uk-img>
      
              </div>
        </div>
    
        <h2 class="uk-text-center" style="font-weight: 600;">Benefits of Laravel</h2> 
        <br>
        <div class="uk-column-1-2@s">
            
           <img data-src="assets/laravel-1.png" width="500" height="100" alt="" uk-img>
            <ul class="uk-list uk-list-disc uk-text-medium uk-text-justify" style="font-size: 18px;">
               
                <li><b>Enhanced Performance-</b>
                    Another stronger reason to choose Laravel is it's capabilities to provide an efficient performance of the web applications
                    </li>
                <li><b>Powerful Authentication-</b>
                    Laravel allows developers to create certain web application functionalities much faster and even in a better way
                    </li>
                <li><b>Open Source & Powerful Community-</b>
                    One major benefit for you to choose Laravel is that it is open-source. But, it is enough for you to choose it over other PHP frameworks
                    </li>
                <li> <b>Database Migration-</b>
                    The migrations allow the developers to easily undo the changes made to the database. In Laravel using migrations, the developers can share the databases to other developers within the team easily and smoothl
                    </li>
                <li><b>Object Oriented Libraries-</b>
                    Laravel is built with Object Oriented libraries. These libraries are in-built and one of them is Authentication library. These libraries are full of excellent features that are easy-to-use and easy-to-implement for the developer in their projects
                    </li>
            
            </ul>
        </div>
        <!--Related services start-->
        <h1 class="uk-text-center" style="margin-bottom: 0px;">Related Services</h1>
        <br>
        <br>
        <div class="uk-container">
            <div class="uk-grid-medium uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match uk-flex-center " uk-grid>
                <div>
                    <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium uk-padding" style="padding-bottom: 10px;">
                        <img class="uk-align-center" src="assets/icons/cbg11.png" width="100" height="100" alt="">
                        <h4 class="uk-text-center"  style="padding-top: 0px; margin-top: 0px; font-weight: 600; ">Custom Business Application</h4>
                    </div>
                 </div>
                <div>
                    <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium uk-padding" style="padding-bottom: 10px;">
                        <img class="uk-align-center" src="assets/icons/phpg5.png" width="100" height="100" alt="">
                        <h4 class="uk-text-center"  style="padding-top: 0px; margin-top: 0px; font-weight: 600; ">Php Application Development</h4>
                    </div>
                </div>
                <div>
                    <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium uk-padding" style="padding-bottom: 10px;">
                        <img class="uk-align-center" src="assets/icons/webdeg.png" width="100" height="100" alt="">
                        <h4 class="uk-text-center"  style="padding-top: 0px; margin-top: 0px; font-weight: 600; ">Web Application Development</h4>
                    </div>
                </div>

                <div>
                    <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium uk-padding" style="padding-bottom: 10px;">
                <img class="uk-align-center" src="assets/icons/cakeg8.png" width="100" height="100" alt="">
                <h4 class="uk-text-center"  style="padding-top: 0px; margin-top: 0px; font-weight: 600; ">CakePhp App Development</h4>

          
        </div>
    </div>

    <div>
       
        <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium uk-padding" style="padding-bottom: 10px;">
                <img class="uk-align-center" src="assets/icons/pythong4.png" width="100" height="100" alt="">
                <h4 class="uk-text-center"  style="padding-top: 0px; margin-top: 0px; font-weight: 600; ">Python Programming</h4>

           
        </div>
    </div>

    <div>
        <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium uk-padding" style="padding-bottom: 10px;">
                <img class="uk-align-center" src="assets/icons/shopifyg7.png" width="100" height="100" alt="">
                <h4 class="uk-text-center"  style="padding-top: 0px; margin-top: 0px; font-weight: 600; ">Ecommerce Web Development</h4>

           
        </div>
    </div>

       
    <div>
        <div class="uk-box-shadow-xlarge uk-box-shadow-hover-medium uk-padding" style="padding-bottom: 10px;">

                <img class="uk-align-center" src="assets/icons/webdesigng12.png" width="100" height="100" alt="">
                <h4 class="uk-text-center"  style="padding-top: 0px; margin-top: 0px; font-weight: 600; ">Web Design And Development</h4>

            </div>
        </div>
       
    </div>

</div>
        </div>
    
<!--related service end-->
<br>
        <h1 class="uk-text-center">Technology Stack</h1>
<br>
<div class="uk-container">
    <div class=" wss uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match" uk-grid>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/thsss.jpg" width="90" height="90"
                    alt="border-circle">
                <h4  style="font-weight: 600;">Wordpress</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/angular.png" width="90" height="90"
                    alt="border-circle">
                <h4  style="font-weight: 600;">Angular JS</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/post.jpg" width="90" height="90"
                    alt="border-circle">
                <h4  style="font-weight: 600;">Postgres SQL</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/html.jpg" width="90" height="90"
                    alt="border-circle">
                <h4  style="font-weight: 600;">Html</h4>
            </div>
        </div>
    </div>
    
    <div class=" wss uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match" uk-grid>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/css-3.png" width="90" height="90"
                    alt="border-circle">
                <h4  style="font-weight: 600;">CSS</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/Redis.png" width="120" height="120"
                    alt="border-circle">
                <h4  style="font-weight: 600;">Redis</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/js-logo.png" width="90" height="90"
                    alt="border-circle">
                <h4  style="font-weight: 600;">JavaScript</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/jest.png" style="width:90px; height:90px"
                    alt="border-circle">
                <h4  style="font-weight: 600;">Jest</h4>
            </div>
        </div>
    </div>
    <div class=" wss uk-child-width-1-2@s uk-child-width-1-4@m uk-grid-match" uk-grid>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/logo.png" width="90" height="90"
                    alt="border-circle">
                <h4  style="font-weight: 600;">Redux</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/Ruby_logo.png" width="90" height="90"
                    alt="border-circle">
                <h4  style="font-weight: 600;">Ruby On Rails</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/aws.png" width="130" height="130"
                    alt="border-circle">
                <h4  style="font-weight: 600;">AWS</h4>
            </div>
        </div>
        <div>


            <div class="uk-placeholder uk-text-center uk-panel uk-padding">

                <img class="uk-border-circle uk-align-center" src="assets/ng.jpg" width="80" height="80"
                    alt="border-circle">
                    <h4  style="font-weight: 600;">Nginx</h4>
            </div>
        </div>
    </div>
</div>
<br>